import React from "react";
import DynamicBreadcrumb from "../../components/DynamicBreadcrumb";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import FaqPage from "./FaqPage";
import TermCondition from "./TermCondition";
import CsrPolicy from "./CsrPolicy";
import PrivacyPolicy from "./PrivacyPolicy";
import Disclaimer from "./Disclaimer";

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Terms & Conditions",
  },
];

export default function TermsAndCondition() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <section className="termscondition-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="quicklinks-box">
                <Tab.Container defaultActiveKey="terms">
                  <Row>
                    <Col md={4} lg={3}>
                      <Nav className="flex-column quicklinks-nav">
                        <span className="heading">Quick Links</span>
                        <Nav.Item>
                          <Nav.Link eventKey="faq">FAQs</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="terms">
                            Terms & Condition
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="csr">CSR Policy</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="privacy">Privacy Policy</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="disclaimer">Disclaimer</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>

                    <Col md={8} lg={9}>
                      <Tab.Content className="quicklinks-content">
                        <Tab.Pane eventKey="faq">
                          <div className="quicklinkfaq-area">
                            <span>FREQUENTLY ASKED QUESTIONS</span>
                            <h1 className="heading">
                              Your questions, our answers
                            </h1>
                            <FaqPage />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="terms">
                          <div className="termscondition-text">
                            <span>TERMS & CONDITIONS</span>
                            <h2 className="heading">Terms of Use</h2>
                            <TermCondition />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="csr">
                          <div className="termscondition-text">
                            <span>CSR Policy</span>
                            <h1 className="heading">Terms of Use</h1>
                            <CsrPolicy />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="privacy">
                          <div className="termscondition-text">
                            <span>Privacy Policy</span>
                            <h1 className="heading">Terms of Use</h1>
                            <PrivacyPolicy />
                          </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="disclaimer">
                          <div className="termscondition-text">
                            <span>Disclaimer</span>
                            <h1 className="heading">Terms of Use</h1>
                            <Disclaimer />
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
